module.exports = "{1} ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-utils-notify/services/notify/toast-templates/no-titled.html
// module id = 442
// module chunks = 0